module.exports = __webpack_public_path__ + "media/country_flags/tr-f3ae6757.png";